import * as React from 'react';

import { FeaturesSection, IFeatureCard } from 'shared/components/FeaturesSection';

import feature1 from 'shared/components/FeaturesSection/assets/feature-1.png';
import feature2 from 'shared/components/FeaturesSection/assets/feature-2.png';
import { useState } from 'react';
import { Modal, useDeviceType } from '@cian/ui-kit';
import { CandidateModal, QualityModal } from '../../components/FeaturesSection/parts';

const FEATURES: IFeatureCard[] = [
  {
    title: 'Лучшие специалисты из партнёрских агентств',
    linkText: 'Как проходит отбор в Циане',
    image: feature1,
    cardType: 'candidate',
  },
  {
    title: 'Профи, которые соблюдают стандарты качества',
    linkText: 'Что мы контролируем',
    image: feature2,
    cardType: 'quality',
  },
];

export const FeaturesSectionContainer: React.FC = () => {
  const [cardModalOpen, setCardModalOpen] = useState(false);
  const [cardType, setCardType] = useState<'candidate' | 'quality'>('candidate');

  const deviceType = useDeviceType();
  const isPhone = deviceType === 'phone';

  const Component = cardType === 'candidate' ? CandidateModal : QualityModal;

  const handleCardModalOpen = React.useCallback((cardType: 'candidate' | 'quality') => {
    setCardType(cardType);
    setCardModalOpen(true);
  }, []);

  const handleCardModalClose = React.useCallback(() => {
    setCardModalOpen(false);
  }, []);

  return (
    <>
      <FeaturesSection features={FEATURES} onCardClick={handleCardModalOpen} />

      <Modal open={cardModalOpen} onOpenChange={handleCardModalClose} size="M">
        <Component onClick={handleCardModalClose} isPhone={isPhone} />
      </Modal>
    </>
  );
};
